import { Abacus } from "core/Abacus.Core";
import { Class } from "core/Abacus.Utilities";
import { SwiperClass } from "core/classes/swiper/swiper.class";
import { MediaQueryPublisher } from "core/classes/media.query.publisher.class";

$(window).on("wallpaper:advert, abacus:loadcontent:complete", function() {
    if (!Abacus.PreventDefault.SPIN2Scroller) {
        $(".spin2scroller:not(.initialized)").each(function() {
            Abacus.Scroller = new Scroller(this, MediaQueryPublisher);
            this.classList.add("initialized");
        });
    }
});

$(document).ready(function() {
    if (!Abacus.PreventDefault.SPIN2Scroller &&
        !$(".spin2scroller").hasClass("initialized")
    ) {
        $(".spin2scroller").each(function() {
            Abacus.Scroller = new Scroller(this, MediaQueryPublisher);
            this.classList.add("initialized");
        });
    }
});

let ScrollerOptions = {
    slidesPerView: "auto",
    scrollerControls: {
        next: ".scrollerControls li.next, .pagination .next",
        previous: ".scrollerControls li.previous, .pagination .previous"
    },

    swiper: {
        slidesPerView: "auto",
        slidesPerGroup: 2,
        breakpoints: {
            480: {
                slidesPerGroup: 1,
                freeMode: true
            },
            780: {
                slidesPerGroup: 2,
                freeMode: false
            },
            1040: {
                slidesPerGroup: 3,
                freeMode: false
            }
        },
        onSlideClick: function() {},
        onTouchEnd: function() {}
    }
};

class Scroller extends Class {
    constructor(element, mqp, options) {
        super();
        this.element = $(element);
        this.mediator = $({});
        this.setOptions(ScrollerOptions, options);
        this.setupPreEvents();
        this.mqp = mqp;
        this.scroller = new SwiperClass(this.element, this.mediator, this.options);
        this.checkButtons();
        this.setupEvents();
        this.setupButtons();
        this.init();
    }

    init() {
        if (this.scroller) return;
    }

    setupPreEvents() {
        this.mediator.on("swiperPreInit", function() {});
    }

    setupButtons() {
        var self = this;

        this.element
            .find(this.options.scrollerControls.previous)
            .off()
            .on("click", function(evt) {
                evt.preventDefault();
                self.scroller.previous();
                self.checkButtons();
            });

        this.element
            .find(this.options.scrollerControls.next)
            .off()
            .on("click", function(evt) {
                evt.preventDefault();
                self.scroller.next();
                self.checkButtons();
            });

        this.scroller.swiper.on("touchEnd", function(swiper) {
            self.checkButtons();
        });

        $(window).on("resize", function(e, breakpoint) {
            self.refresh();
        });

        $(window).on("wallpaper:advert", function() {
            self.refresh();
        });
    }

    setupEvents() {
        var self = this;

        this.mediator.on("swiperLoaded", function(evt, element) {
            if (self.options.hasPagination) {
                self.setupButtons();
            }
        });
    }

    refresh() {
        var self = this;
        setTimeout(function() {
            //self.scroller.reInit();
            self.scroller.swiper.update();
            self.checkButtons();
        }, 0);
    }

    checkButtons() {
        if (this.scroller.swiper.isBeginning) {
            this.element
                .find(this.options.scrollerControls.previous)
                .addClass("disabled");
        } else {
            this.element
                .find(this.options.scrollerControls.previous)
                .removeClass("disabled");
        }

        if (this.scroller.swiper.isEnd) {
            this.element
                .find(this.options.scrollerControls.next)
                .addClass("disabled");
        } else {
            this.element
                .find(this.options.scrollerControls.next)
                .removeClass("disabled");
        }
    }

    updateScroller(index) {
        this.scroller.goToSlide(index);
    }
}

export { Scroller };


// WEBPACK FOOTER //
// ./Javascript/core/classes/scrollers/scroller.class.js